<template>
    <div class="tenantMain">
        <div class="tenantCard tenantWelcome text-center">
            <div class="header">
                <img src="/img/tenants-logo.png" alt="">
            </div>
            <div class="main">
                <p>Welcome to the <b>Tenants Feedback page.</b>
                    <br/><br/>
                    Your inputs are important to us. If you wish to report an incident/fault or a feedback, click on the Submit a Feedback Button below to proceed.
                </p>
                <gofix-button label="Submit feedback" large @click="nextStep"></gofix-button>
            </div>
            <div class="footer">
                <p class="m-0">**Necessary contact information will be collected for our friendly Help Desk to be able to reach out to you.</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'tenant-welcome',
        data () {
            return {
            }
        },
        created() {

        },
        methods:{
            nextStep(){
                this.$emit("next-step");
            }
        }
    }
</script>
